module.exports = __webpack_public_path__ + "img/openbadge-intro-2.921fdfb6.png";